import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ThemeService } from 'shared';
import { TranslateService } from 'shared';

@Component({
    selector: 'app-app-settings',
    templateUrl: './app-settings.component.html',
    styleUrls: ['./app-settings.component.scss'],
    standalone: false
})
export class AppSettingsComponent {

  appLanguages:any[] = [
    {name:' English (en)', abbv:'en'},
    {name:' Deutsch (de)', abbv:'de'}
  ];

  constructor(public translate: TranslateService,
    private themeService: ThemeService) { }

  actLang = (localStorage.getItem('app_lang') != "")?localStorage.getItem('app_lang'):'de';  

  setLang(lang: string) {
    this.translate.use(lang).then(() => { 
      console.log(lang)
    });
    localStorage.setItem('app_lang', lang);
    this.actLang = lang;
  }

  updateTheme(theme: string) {
    this.themeService.updateThemeUrl(theme);
  }

}
